export default function Footer(){
    return (
        <div className="footer container">
            <div className="footer-section">
                <p className="title">FoodiesHub.com</p>
                <p>FoodiesHub is a place where you can please your soul and tummy with delicious food recipes of all cuisine. And our service is absolutely free.</p>
                <p>&copy; 2023 | All Rights Reserved</p>
            </div>
            <div className="footer-section">
                <p className="title">Contact Us</p>
                <p>foodieshub@gmail.com</p>
                <p>01234567896</p>
                <p>Oxygen, Wazedia, Bayezid, Chattogram</p>
            </div>
            <div className="footer-section">
                <p className="title">Socials</p>
                <p>Facebook</p>
                <p>Twitter</p>
                <p>Instagram</p>
            </div>
        </div>
    )
}